import {
  coreTransformMiddleware as core,
  TransformCollection as Collection,
  createTransformMiddleware as createMiddleware,
} from 'smarthub-core'
import {
  IMiddlewareConfig,
  ITransformHandler,
  ITransformMiddlewareCollection,
  TransformMiddleware,
} from 'smarthub-common'

export const transformMiddleware = (): IMiddlewareConfig<
  TransformMiddleware,
  ITransformHandler,
  ITransformMiddlewareCollection
> => {
  const collection = new Collection()
  const middleware = createMiddleware(core, collection.middleware)
  return {
    middleware,
    collection,
  }
}
